// Maxa.StockByLocation - entry point (v1.0.0, phase 1)
//
// PRODUCT PAGE (all logged-in customers)
//   The theme's own stock line is left as it is (green "In Stock" + "Order before 4.30pm..."
//   or the red "Awaiting Stock" message). Only its "Quantity Available" line is hidden, and
//   two flags are added underneath:
//     Union Flag  "GB stock"       = 01 Watford Main stock (selling units)
//     Irish flag  "Ireland stock"  = 3PL Ireland - SJ Henderson stock (selling units)
//   No hover/tap tooltips - delivery times are covered by the Shipping Policy.
//
// SEARCH / CATEGORY RESULTS ("In Stock" tag on item cells)
//   Irish customers (profile custentity_maxa_default_trn_location = 312):
//     SJH >= 1                  -> "In Stock"
//     SJH = 0 and Watford >= 1  -> "4-6 day lead time" (amber, same size as Add to Cart)
//     both 0                    -> no tag
//   Everyone else (UK):
//     Watford + SJH combined >= 1 -> "In Stock", otherwise no tag
//
// Display only - ordering/backorder behaviour is unchanged.
// Debug helper (browser console): MaxaStockByLocationTest('374,376,388')
define('Maxa.StockByLocation.StockByLocation', [
    'Maxa.StockByLocation.StockByLocation.SS2Model',
    'Utils',
    'jQuery'
], function (
    StockSS2Model,
    Utils,
    jQuery
) {
    'use strict';

    var SJH_LOCATION_ID = '312';
    var IRISH_FIELD = 'custentity_maxa_default_trn_location';
    var CACHE_MS = 60 * 1000;

    var TEXT = {
        gbLabel: 'GB stock',
        ieLabel: 'Ireland stock',
        inStock: 'In Stock',
        leadTime: '4-6 day lead time'
    };

    var CSS = [
        '.sbl-flags{display:flex;flex-wrap:wrap;gap:10px;margin:6px 0 14px;}',
        '.sbl-flag{display:inline-flex;align-items:center;gap:8px;padding:6px 10px;border:1px solid #ddd;border-radius:4px;background:#fff;font-size:.9rem;color:#000;line-height:1.2;}',
        '.sbl-flag svg{width:30px;height:15px;flex:0 0 auto;border:1px solid #ccc;}',
        '.sbl-flag-label{color:#555;}',
        '.sbl-flag-qty{font-weight:bold;}',
        '.sbl-flag-qty.sbl-zero{color:#999;}',
        '.sbl-hide{display:none !important;}',
        // Lead-time tag sized to match the tile's "Add to Cart" button (114 x 36px) on one line.
        '.facet-item-sku-stock .item-stock.sbl-lead{background:#f5a623 !important;color:#000 !important;' +
            'box-sizing:border-box !important;width:114px !important;height:36px !important;padding:0 4px !important;' +
            'display:flex !important;align-items:center !important;justify-content:center !important;' +
            'white-space:nowrap !important;font-size:12px !important;line-height:1 !important;text-align:center !important;}'
    ].join('');

    var flagCounter = 0;

    function unionFlagSvg() {
        flagCounter += 1;
        var s = 'sblS' + flagCounter;
        var t = 'sblT' + flagCounter;
        return '<svg viewBox="0 0 60 30" aria-hidden="true" focusable="false">' +
            '<clipPath id="' + s + '"><path d="M0,0 v30 h60 v-30 z"/></clipPath>' +
            '<clipPath id="' + t + '"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>' +
            '<g clip-path="url(#' + s + ')">' +
            '<path d="M0,0 v30 h60 v-30 z" fill="#012169"/>' +
            '<path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/>' +
            '<path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#' + t + ')" stroke="#C8102E" stroke-width="4"/>' +
            '<path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/>' +
            '<path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/>' +
            '</g></svg>';
    }

    function irishFlagSvg() {
        return '<svg viewBox="0 0 60 30" aria-hidden="true" focusable="false">' +
            '<rect width="20" height="30" x="0" fill="#169B62"/>' +
            '<rect width="20" height="30" x="20" fill="#FFFFFF"/>' +
            '<rect width="20" height="30" x="40" fill="#FF883E"/>' +
            '</svg>';
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    // ---------------------------------------------------------------- data

    var stockCache = {}; // itemId -> { at: ms, data: {...} }

    function fetchStock(itemIds, debug) {
        var now = Date.now();
        var result = {};
        var missing = [];
        itemIds.forEach(function (id) {
            var c = stockCache[id];
            if (c && now - c.at < CACHE_MS && !debug) {
                result[id] = c.data;
            } else {
                missing.push(id);
            }
        });
        if (!missing.length) {
            return jQuery.Deferred().resolve({ ok: true, stock: result }).promise();
        }
        var model = new StockSS2Model();
        var data = { items: missing.join(',') };
        if (debug) { data.debug = 'T'; }
        return model.fetch({ data: data }).then(function () {
            var json = model.toJSON();
            var stock = json.stock || {};
            Object.keys(stock).forEach(function (id) {
                stockCache[id] = { at: Date.now(), data: stock[id] };
                result[id] = stock[id];
            });
            json.stock = result;
            return json;
        });
    }

    var irishPromise = null;

    function isIrishCustomer() {
        if (!irishPromise) {
            irishPromise = jQuery.ajax({
                url: Utils.getAbsoluteUrl('services/Profile.Service.ss'),
                dataType: 'json',
                cache: false
            }).then(function (profile) {
                var fields = (profile && profile.customfields) || [];
                for (var i = 0; i < fields.length; i++) {
                    if (fields[i] && fields[i].name === IRISH_FIELD) {
                        return String(fields[i].value) === SJH_LOCATION_ID;
                    }
                }
                return false;
            }, function () {
                irishPromise = null; // allow retry later
                return false;
            });
        }
        return irishPromise;
    }

    // ---------------------------------------------------------------- results page (item cells)

    function updateCells() {
        var cells = document.querySelectorAll('[data-type="item"][data-item-id]:not([data-sbl-done])');
        if (!cells.length) { return; }

        var byId = {};
        Array.prototype.forEach.call(cells, function (cell) {
            cell.setAttribute('data-sbl-done', 'pending');
            var id = parseInt(cell.getAttribute('data-item-id'), 10);
            if (id > 0) {
                (byId[id] = byId[id] || []).push(cell);
            }
        });
        var ids = Object.keys(byId);
        if (!ids.length) { return; }

        jQuery.when(isIrishCustomer(), fetchStock(ids)).then(function (irish, json) {
            var stock = (json && json.stock) || {};
            ids.forEach(function (id) {
                var s = stock[id];
                byId[id].forEach(function (cell) {
                    cell.setAttribute('data-sbl-done', '1');
                    if (s) { setCellTag(cell, irish, s); }
                });
            });
        }, function () {
            ids.forEach(function (id) {
                byId[id].forEach(function (cell) { cell.setAttribute('data-sbl-done', 'error'); });
            });
        });
    }

    function setCellTag(cell, irish, s) {
        var holder = cell.querySelector('.facet-item-sku-stock');
        if (!holder) { return; }
        var tag = holder.querySelector('.item-stock');

        var text = null;
        var lead = false;
        if (irish) {
            if (s.sjh >= 1) {
                text = TEXT.inStock;
            } else if (s.watford >= 1) {
                text = TEXT.leadTime;
                lead = true;
            }
        } else if (s.combined >= 1) {
            text = TEXT.inStock;
        }

        if (!text) {
            if (tag) { tag.parentNode.removeChild(tag); }
            return;
        }
        if (!tag) {
            tag = document.createElement('span');
            tag.className = 'item-stock';
            holder.appendChild(tag);
        }
        tag.textContent = text;
        tag.classList.toggle('sbl-lead', lead);
    }

    // ---------------------------------------------------------------- product page

    function currentPdpItemId(pdp) {
        try {
            if (pdp && typeof pdp.getSelectedMatrixChilds === 'function') {
                var childs = pdp.getSelectedMatrixChilds() || [];
                if (childs.length === 1 && childs[0] && childs[0].internalid) {
                    return parseInt(childs[0].internalid, 10);
                }
            }
            var info = pdp && typeof pdp.getItemInfo === 'function' ? pdp.getItemInfo() : null;
            var item = info && info.item;
            return item && item.internalid ? parseInt(item.internalid, 10) : null;
        } catch (e) {
            return null;
        }
    }

    function updatePdp(pdp, force) {
        var header = document.querySelector('.product-details-full-content-header');
        if (!header) { return; }

        var itemId = currentPdpItemId(pdp);
        if (!itemId) { return; }
        if (!force && header.getAttribute('data-sbl-item') === String(itemId)) { return; }
        header.setAttribute('data-sbl-item', String(itemId));

        // Keep the theme's "In Stock" / "Order before 4.30pm" / "Awaiting Stock" lines.
        // Only hide its single "Quantity Available" figure - the flags show the per-location quantities.
        Array.prototype.forEach.call(header.children, function (el) {
            if (el.tagName === 'H3' && /Quantity Available/i.test(el.textContent)) {
                el.classList.add('sbl-hide');
            }
        });

        fetchStock([itemId]).then(function (json) {
            var s = json && json.stock && json.stock[itemId];
            if (!s || header.getAttribute('data-sbl-item') !== String(itemId)) { return; }
            renderPdpFlags(header, s);
        });
    }

    function flagBadge(svg, label, qty) {
        return '<span class="sbl-flag" aria-label="' + escapeHtml(label + ': ' + qty) + '">' +
            svg +
            '<span class="sbl-flag-label">' + escapeHtml(label) + '</span>' +
            '<span class="sbl-flag-qty' + (qty > 0 ? '' : ' sbl-zero') + '">' + escapeHtml(qty) + '</span>' +
            '</span>';
    }

    function renderPdpFlags(header, s) {
        var existing = header.querySelector('.sbl-pdp');
        if (existing) { existing.parentNode.removeChild(existing); }

        var wrap = document.createElement('div');
        wrap.className = 'sbl-pdp';
        wrap.innerHTML =
            '<div class="sbl-flags">' +
            flagBadge(unionFlagSvg(), TEXT.gbLabel, s.watford) +
            flagBadge(irishFlagSvg(), TEXT.ieLabel, s.sjh) +
            '</div>';

        var anchor = header.querySelector('[data-view="ItemDetails.Header"]');
        if (anchor && anchor.parentNode === header) {
            header.insertBefore(wrap, anchor);
        } else {
            header.appendChild(wrap);
        }
    }


    // ---------------------------------------------------------------- wiring

    function addStyles() {
        if (document.getElementById('sbl-styles')) { return; }
        var style = document.createElement('style');
        style.id = 'sbl-styles';
        style.appendChild(document.createTextNode(CSS));
        document.head.appendChild(style);
    }

    return {
        mountToApp: function mountToApp(container) {
            var pdp = container.getComponent('PDP');

            window.MaxaStockByLocationTest = function (itemIds) {
                return jQuery.when(isIrishCustomer(), fetchStock(String(itemIds || '').split(','), true))
                    .then(function (irish, json) {
                        var out = { isIrish: irish, response: json };
                        console.log('[MaxaStockByLocation]', JSON.stringify(out));
                        return out;
                    });
            };

            if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
                return; // not in a browser (e.g. server-side rendering)
            }

            addStyles();

            var timer = null;
            function scan() {
                timer = null;
                updateCells();
                updatePdp(pdp, false);
            }
            new MutationObserver(function () {
                if (!timer) { timer = setTimeout(scan, 150); }
            }).observe(document.body, { childList: true, subtree: true });

            if (pdp && typeof pdp.on === 'function') {
                pdp.on('afterOptionSelection', function () {
                    setTimeout(function () { updatePdp(pdp, true); }, 50);
                });
            }

            scan();
        }
    };
});
